import { nanoid } from 'nanoid';

import { VariantId } from '@candu-ai/content/types';
import { BuiltInComponents } from 'craft/constants';
import {
  CssSelectorDefinitions,
  CssSelectorId,
  CssSelectorType,
  INTERACTION_TYPES,
  SerializedNodeTree,
} from 'craft/types';

interface Props {
  contentName: string;
  variantId: VariantId;
}

export const getSubsequentHotspot = ({ contentName, variantId }: Props) =>
  (({
    rootNodeId: '3bBlLh',
    nodes: {
      '3bBlLh': {
        type: {
          resolvedName: BuiltInComponents.Hotspot,
        },
        props: {
          stateId: nanoid(6),
          dismissBehaviour: 'dismiss',
          variant: variantId,
        },
        name: 'Hotspot',
        custom: {
          actions: [
            {
              eventName: `Dismissed Hotspot ${contentName}`,
              category: INTERACTION_TYPES.Dismiss,
            },
          ],
          cssSelectors: {
            [CssSelectorId.HotspotBody]: {
              selector: CssSelectorDefinitions[CssSelectorId.HotspotBody].selector,
              type: CssSelectorType.HTML,
              css: {
                width: '300px',
              },
            },
          },
        },
      },
    },
  } as unknown) as SerializedNodeTree);
